<div *ngFor="let item of processoGrupoList; let indexGroup = index">
    <div class="row wrapper border-bottom page-heading px-0">
        <div class="col-lg-4">
            <h2>{{item?.name}}</h2>
        </div>
        <div class="col-lg-8 d-flex justify-content-end d-wrap px-3" *ngIf="item.can_save">
            <div class="btn-search" [ngClass]="{'question-btn': item?.active_ord}" *ngIf="item?.items?.length">
                <button class="btn btn-default btn_order" type="btn" *ngIf="!item?.active_ord" (click)="item.active_ord = true">Ordenar</button>
                <button class="btn btn-primary btn_order" type="btn" *ngIf="item?.active_ord" (click)="salvarOrdem(indexGroup)">Salvar Ordem</button>
            </div>
            <div>
                <a class="btn btn-primary btn-new-group" type="btn"  [routerLink]="['/pre-projeto','processos','grupos',item.id,'adicionar']">Novo Grupo</a>
            </div>
        </div>
    </div>

    <div class="system-table table-container">
        <div class="system-table-conteiner">
            <table  cdkDropList (cdkDropListDropped)="drop($event, indexGroup)" [cdkDropListDisabled]="!item?.active_ord" [ngClass]="{'ordenacao': item?.active_ord}">
                <thead>
                    <tr>
                        <th *ngIf="item?.active_ord" class="width5">Ordenação</th>
                        <th class="width5">Código</th>
                        <th>Item</th>
                        <th class="text-center width5">Ações</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let it of item.items; let i = index">
                        <tr cdkDrag>
                            <td class="title text-center" *ngIf="item?.active_ord">{{ i + 1 }}</td>
                            <td class="text-center" [ngClass]="{'title': !ordenacao}">{{ it?.id }}</td>
                            <td>
                                <span class="title-span">{{it?.name}}</span>
                            </td>
                            <td>
                                <div class="btn-icon">
                                    <a class="icon-table" [routerLink]="editar(it?.id)">
                                        <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="!processoGrupoList?.length" class="border-b-radius">
                        <td colspan="4" class="text-center">Nenhum grupo cadastrado.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
    </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
